module.exports = __webpack_public_path__ + "static/media/2.559110e6.jpg";